import numberWithDecimals from './numberWithDecimals';

const CRYPTO_DECIMAL_PLACES = 8;

const roundCrypto = (value: number, decimals = CRYPTO_DECIMAL_PLACES) =>
  numberWithDecimals(value, decimals).toString();

export default roundCrypto;
